import styled from "styled-components";

export const UniversalExpandersStyles = styled.main`
	.body{
		margin:6%;
	}
`